var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 250,
    viewBox: "0 0 278 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.629 87.963H101.852V106.481H129.629V87.963Z",
    fill: "#F4ECCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2223 180.556H18.5186V245.37H97.2223V180.556Z",
    fill: "#BA9BC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.259 171.296V175.926L129.63 106.482H101.852L92.5928 245.37H134.259H138.889H263.889V171.296H134.259Z",
    fill: "#838BC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.186 152.778L189.815 106.482H208.334L212.963 152.778",
    fill: "#8F6C56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.852 152.778L231.481 106.482H250L254.629 152.778",
    fill: "#8F6C56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.519 152.778L148.148 106.482H166.667L171.296 152.778",
    fill: "#8F6C56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125 78.7037V51.9444C127.478 49.7999 129.117 46.8481 129.629 43.6111C132.419 45.3204 135.617 46.2478 138.888 46.2963C142.343 46.2859 145.727 45.3092 148.656 43.4766C151.584 41.644 153.942 39.0285 155.462 35.9259C156.733 37.6526 158.385 39.0618 160.291 40.0432C162.197 41.0247 164.304 41.5517 166.447 41.5831C168.59 41.6145 170.712 41.1494 172.645 40.2242C174.579 39.2989 176.272 37.9387 177.592 36.25C179.094 39.9894 181.546 43.272 184.706 45.7731C187.865 48.2742 191.623 49.9071 195.607 50.5104C199.592 51.1137 203.664 50.6663 207.423 49.2127C211.181 47.7591 214.495 45.3495 217.037 42.2222C220.188 47.3981 224.945 51.4017 230.582 53.6226C236.22 55.8435 242.43 56.1599 248.264 54.5237C254.099 52.8874 259.238 49.3882 262.899 44.5594C266.56 39.7307 268.541 33.8373 268.541 27.7778C268.541 21.7182 266.56 15.8249 262.899 10.9961C259.238 6.1674 254.099 2.66818 248.264 1.03191C242.43 -0.604364 236.22 -0.287921 230.582 1.93299C224.945 4.15391 220.188 8.15747 217.037 13.3333C214.495 10.2061 211.181 7.7965 207.423 6.34286C203.664 4.88922 199.592 4.44191 195.607 5.04517C191.623 5.64843 187.865 7.28136 184.706 9.78245C181.546 12.2835 179.094 15.5661 177.592 19.3056C176.272 17.6169 174.579 16.2566 172.645 15.3314C170.712 14.4062 168.59 13.9411 166.447 13.9724C164.304 14.0038 162.197 14.5309 160.291 15.5123C158.385 16.4938 156.733 17.903 155.462 19.6296C153.605 15.9026 150.546 12.9104 146.779 11.1361C143.011 9.36176 138.756 8.90897 134.7 9.85079C130.643 10.7926 127.023 13.0741 124.423 16.3268C121.823 19.5796 120.395 23.6137 120.37 27.7778C120.37 28.0556 120.37 28.3796 120.37 28.6574C118.891 28.0926 117.323 27.7948 115.74 27.7778C112.944 27.7943 110.218 28.6546 107.918 30.2461C105.619 31.8375 103.853 34.086 102.853 36.6973C101.852 39.3086 101.664 42.161 102.311 44.8815C102.958 47.6019 104.412 50.0636 106.481 51.9444V78.7037H125Z",
    fill: "#BA9BC9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.63 152.778H143.519C135.848 152.778 129.63 158.996 129.63 166.667C129.63 174.337 135.848 180.556 143.519 180.556H254.63C262.301 180.556 268.519 174.337 268.519 166.667C268.519 158.996 262.301 152.778 254.63 152.778Z",
    fill: "#BA9BC9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.778 240.741H0V250H277.778V240.741Z",
    fill: "#8F6C56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7773 180.556L32.407 134.259H50.9255L55.5551 180.556",
    fill: "#8F6C56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.296 199.074H152.777V226.852H171.296V199.074Z",
    fill: "#F4ECCE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M245.37 199.074H226.852V226.852H245.37V199.074Z",
    fill: "#F4ECCE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M208.333 199.074H189.814V226.852H208.333V199.074Z",
    fill: "#F4ECCE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 194.444H32.4072V203.704H41.6665V194.444Z",
    fill: "#F4ECCE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.185 194.444H50.9258V203.704H60.185V194.444Z",
    fill: "#F4ECCE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7036 194.444H69.4443V203.704H78.7036V194.444Z",
    fill: "#F4ECCE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 212.963H32.4072V222.222H41.6665V212.963Z",
    fill: "#F4ECCE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.185 212.963H50.9258V222.222H60.185V212.963Z",
    fill: "#F4ECCE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7036 212.963H69.4443V222.222H78.7036V212.963Z",
    fill: "#F4ECCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolution);
export default __webpack_public_path__ + "static/media/Polution.29e331d26e7dd739359409b98c70f802.svg";
export { ForwardRef as ReactComponent };